module.exports = __webpack_public_path__ + "img/brush.6d043f35.svg";